import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React, { Component, isValidElement, Children, cloneElement } from 'react';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import ResponsiveContext from '../ResponsiveContext';
import RegistryContext from './RegistryContext';
import ToolbarGroup from './ToolbarGroup';
import ToolbarExpander from './ToolbarExpander';

var ToolbarItem =
/*#__PURE__*/
function (_Component) {
  _inherits(ToolbarItem, _Component);

  function ToolbarItem() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ToolbarItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ToolbarItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      compact: false
    });

    return _this;
  }

  _createClass(ToolbarItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var registry = this.context;
      registry.register(this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var registry = this.context;
      registry.unregister(this);
    }
  }, {
    key: "isCompact",
    value: function isCompact() {
      return this.state.compact;
    }
  }, {
    key: "setCompact",
    value: function setCompact(compact) {
      this.setState({
        compact: compact
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var compact = this.state.compact;
      return React.createElement(ResponsiveContext.Provider, {
        value: compact
      }, children);
    }
  }]);

  return ToolbarItem;
}(Component);

ToolbarItem.contextType = RegistryContext;
export var toToolbarItems = function toToolbarItems(children) {
  return Children.map(children, function (child) {
    if (!isValidElement(child)) {
      return child;
    }

    if (child.type === ToolbarGroup || child.type === ToolbarExpander) {
      return child;
    }

    return React.createElement(ToolbarItem, null, cloneElement(child, {
      className: classNames(child.props.className, "".concat(CLS_PREFIX, "toolbar__group-item"))
    }));
  });
};